import { FC } from 'react';
import { useSnapshot } from 'valtio';
import { closeExcludeIssueModal } from '../../common/store-actions/issues-exclusions-store-actions';
import IssuesExclusionsStore from '../../common/stores/issues-exclusions-store';
import { Issue } from '../../common/types/issues-types';
import PipelineIssuesOptions from '../components/PipelineIssuesOptions';

import PipelineIssuesStore from '../stores/pipeline-issues-store';

const IssueOptionsContainer: FC<
  React.PropsWithChildren<IssueOptionsContainerProps>
> = ({ issue }) => {
  const { policyDisableModal, isActiveJiraConnection } =
    useSnapshot(PipelineIssuesStore);
  const { exclusionsCategories } = useSnapshot(IssuesExclusionsStore);

  return (
    <PipelineIssuesOptions
      policyDisableModal={policyDisableModal}
      exclusionsCategories={exclusionsCategories}
      handleExcludeAlert={closeExcludeIssueModal}
      isActiveJiraConnection={isActiveJiraConnection}
      isPRAvailable={issue.isPRAvailable}
      fixIssue={issue.fixIssue}
      issueId={issue.issueId}
      isExcluded={issue.excludedByAlert}
    />
  );
};

export interface IssueOptionsContainerProps {
  issue: Issue;
}

export default IssueOptionsContainer;
